import { useGetTagsQuery } from '../../../api/ua-insights'
import { LISTING_PAGE_LIMIT } from '../helpers/listing'
import { useUAInsightsScope } from './useUAInsightsNavigation'

/** Every tag value of one dimension, including those with no creatives in scope. */
export const useDimensionTagsListing = (dimensionId: string | null) => {
  const { networkId, month } = useUAInsightsScope()
  const { data, isFetching, isError, refetch } = useGetTagsQuery(
    { dimensionId: dimensionId ?? undefined, includeEmpty: true, networkId: networkId ?? undefined, month: month ?? undefined, limit: LISTING_PAGE_LIMIT },
    { skip: !dimensionId }
  )
  return { data: data ? { tags: data.tags, total: data.page.total } : undefined, isLoading: isFetching, isError, refetch }
}
